import {
  SiDocker, SiKubernetes,
  SiTerraform, SiGithub, SiPython, SiNodedotjs, SiReact, SiAngular,
  SiDotnet, SiOpenjdk, SiPostgresql, SiMongodb,
  SiRedis, SiLinux, SiGit, SiPrometheus, SiGrafana, SiElastic,
  SiArgo, SiHelm, SiAnsible,
} from "react-icons/si";
import { FaAws, FaMicrosoft, FaGoogle } from "react-icons/fa";
import { Cloud, GitBranch, Code2, BrainCircuit, Users, RefreshCw, Bot } from "lucide-react";

export const SERVICES = [
  {
    id: "cloud",
    icon: Cloud,
    title: "Cloud Engineering",
    tagline: "Azure · AWS · Google Cloud",
    desc: "Cloud-native architecture, migration, optimization, security and landing zones engineered for enterprise scale.",
    image: "https://images.pexels.com/photos/37730212/pexels-photo-37730212.jpeg",
    points: ["Cloud Migration", "Cloud Optimization", "Cloud Security", "Landing Zones"],
  },
  {
    id: "devops",
    icon: GitBranch,
    title: "DevOps & Platform",
    tagline: "CI/CD · Kubernetes · IaC",
    desc: "Automation-first delivery pipelines, GitOps, SRE and platform engineering that ship releases with confidence.",
    image: "https://images.pexels.com/photos/34803969/pexels-photo-34803969.jpeg",
    points: ["CI/CD Pipelines", "Kubernetes & Docker", "Terraform & Bicep", "SRE & Monitoring"],
  },
  {
    id: "software",
    icon: Code2,
    title: "Software Development",
    tagline: "Web · Mobile · SaaS · APIs",
    desc: "Enterprise applications, SaaS platforms, microservices and modern UI built for performance and longevity.",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c",
    points: ["Enterprise Apps", "Microservices", "APIs & Integrations", "Modern UI"],
  },
  {
    id: "ai",
    icon: BrainCircuit,
    title: "AI & Machine Learning",
    tagline: "GenAI · LLMs · Automation",
    desc: "Generative AI, LLM solutions, intelligent search, AI assistants and predictive analytics embedded into your workflows.",
    image: "https://images.pexels.com/photos/17483874/pexels-photo-17483874.png",
    points: ["Enterprise AI", "LLM Solutions", "AI Automation", "Predictive Analytics"],
  },
  {
    id: "staffing",
    icon: Users,
    title: "IT Staffing",
    tagline: "Teams · Contract · Offshore",
    desc: "Dedicated development teams, staff augmentation and elite remote engineers who plug straight into your roadmap.",
    image: "https://images.pexels.com/photos/6804068/pexels-photo-6804068.jpeg",
    points: ["Dedicated Teams", "Staff Augmentation", "Offshore Engineers", "Permanent Hiring"],
  },
  {
    id: "transformation",
    icon: RefreshCw,
    title: "Digital Transformation",
    tagline: "Modernize · Automate · Scale",
    desc: "Legacy modernization, process automation and cloud transformation guided by senior technology consulting.",
    image: "https://images.unsplash.com/photo-1644325349124-d1756b79dd42",
    points: ["Legacy Modernization", "Process Automation", "Cloud Transformation", "Consulting"],
  },
];

export const TECHS = [
  { icon: FaMicrosoft, name: "Azure" },
  { icon: FaAws, name: "AWS" },
  { icon: FaGoogle, name: "Google Cloud" },
  { icon: SiDocker, name: "Docker" },
  { icon: SiKubernetes, name: "Kubernetes" },
  { icon: SiTerraform, name: "Terraform" },
  { icon: SiGithub, name: "GitHub" },
  { icon: SiPython, name: "Python" },
  { icon: SiNodedotjs, name: "Node.js" },
  { icon: SiReact, name: "React" },
  { icon: SiAngular, name: "Angular" },
  { icon: SiDotnet, name: ".NET" },
  { icon: SiOpenjdk, name: "Java" },
  { icon: Bot, name: "OpenAI" },
  { icon: BrainCircuit, name: "LangChain" },
  { icon: SiPostgresql, name: "PostgreSQL" },
  { icon: SiMongodb, name: "MongoDB" },
  { icon: SiRedis, name: "Redis" },
  { icon: SiLinux, name: "Linux" },
  { icon: SiGit, name: "Git" },
  { icon: SiPrometheus, name: "Prometheus" },
  { icon: SiGrafana, name: "Grafana" },
  { icon: SiElastic, name: "ELK" },
  { icon: SiArgo, name: "ArgoCD" },
  { icon: SiHelm, name: "Helm" },
  { icon: SiAnsible, name: "Ansible" },
];

export const STATS = [
  { value: 250, suffix: "+", label: "Projects Delivered" },
  { value: 120, suffix: "+", label: "Cloud Migrations" },
  { value: 800, suffix: "+", label: "DevOps Pipelines" },
  { value: 98, suffix: "%", label: "Satisfied Clients" },
  { value: 10, suffix: "+", label: "Years of Experience" },
];

export const WHY = [
  { n: "01", title: "Engineering Excellence", desc: "Senior engineers and certified experts who treat your architecture like their own." },
  { n: "02", title: "Automation First", desc: "Everything that can be automated, is — from infra to delivery to observability." },
  { n: "03", title: "Cloud Native", desc: "Designed for scale, resilience and cost efficiency across every major cloud." },
  { n: "04", title: "Security by Design", desc: "Zero-trust principles, compliance and hardening baked into every layer." },
  { n: "05", title: "Innovation Driven", desc: "AI-ready systems that keep you ahead of the curve, not chasing it." },
  { n: "06", title: "24×7 Partnership", desc: "Round-the-clock support and SRE that keeps you online, always." },
];

export const PROCESS = [
  { step: "01", title: "Discovery", desc: "We map your goals, constraints and current landscape." },
  { step: "02", title: "Architecture", desc: "Blueprint scalable, secure, cloud-native foundations." },
  { step: "03", title: "Planning", desc: "Roadmaps, milestones and success metrics defined." },
  { step: "04", title: "Development", desc: "Ship quality software with automation-first delivery." },
  { step: "05", title: "Deployment", desc: "Zero-downtime releases via CI/CD and GitOps." },
  { step: "06", title: "Optimization", desc: "Continuous tuning for performance and cost." },
  { step: "07", title: "Support", desc: "24×7 SRE, monitoring and evolution." },
];

export const INDUSTRIES = [
  "Financial Services", "Healthcare", "Retail & E-commerce", "Manufacturing",
  "Logistics", "SaaS & Startups", "Government", "Energy",
];

export const CASES = [
  { tag: "Cloud", title: "Global bank cuts cloud spend 42%", desc: "Re-architected a multi-region Azure landing zone with automated FinOps guardrails.", metric: "42%", metricLabel: "cost reduction" },
  { tag: "DevOps", title: "From weekly to 40 deploys a day", desc: "Kubernetes + GitOps pipeline transformation for a fintech scale-up.", metric: "40x", metricLabel: "deploy frequency" },
  { tag: "AI", title: "LLM assistant deflects 68% of tickets", desc: "Enterprise RAG assistant integrated across support and internal knowledge.", metric: "68%", metricLabel: "ticket deflection" },
];

export const PRODUCTS = [
  {
    id: "vynfive-billing",
    tagline: "Billing & GST Automation",
    title: "VynFive Billing",
    desc: "Mobile-first B2B and B2C billing for shopkeepers, with GST return-ready data, invoice automation and CA filing support at low cost.",
    points: ["GST-ready billing", "Customer-facing mobile invoices", "CA-friendly return data", "Affordable compliance support"],
  },
  {
    id: "vynfive-realestate-crm",
    tagline: "Real Estate CRM",
    title: "VynFive RealEstate CRM",
    desc: "End-to-end property, lead, employee and financial workflow management with AI property suggestions and WhatsApp, call and SMS follow-up integration.",
    points: ["Property & lead workflow", "Employee task tracking", "AI-driven property suggestions", "WhatsApp / call / SMS outreach"],
  },
];

export const TESTIMONIALS = [
  { quote: "VynFive rebuilt our platform on Kubernetes and our release velocity is unrecognisable. True engineering partners.", name: "Amit Kumar", role: "Director, Gemperts" },
  { quote: "Their AI team shipped a production LLM assistant in weeks. The craft and rigour were exceptional.", name: "Malay Sevak", role: "Director, NND Techlabs" },
  { quote: "A cloud migration that actually came in under budget and ahead of schedule. Rare and impressive.", name: "Priya Nair", role: "Director of IT, Meridian Health" },
];

export const FAQS = [
  { q: "What engagement models do you offer?", a: "Fixed-scope projects, dedicated teams, staff augmentation and managed services. We adapt to how you want to work." },
  { q: "Which clouds do you specialise in?", a: "Azure, AWS and Google Cloud — including migration, landing zones, optimization and security across all three." },
  { q: "Can you work with our existing team?", a: "Absolutely. Our engineers integrate directly into your workflows, tooling and ceremonies." },
  { q: "How do you approach AI projects?", a: "We start with a focused discovery, build a secure architecture, then ship production-grade GenAI/LLM solutions with measurable outcomes." },
  { q: "Do you provide ongoing support?", a: "Yes — 24×7 SRE, monitoring and continuous optimization are part of our long-term partnerships." },
];

export const NAV = [
  { label: "Services", href: "#services" },
  { label: "Products", href: "#products" },
  { label: "Technologies", href: "#tech" },
  { label: "Work", href: "#work" },
  { label: "Process", href: "#process" },
  { label: "Company", href: "#about" },
];
